import { Component, ViewChild } from '@angular/core';
import { IonContent, ModalController } from '@ionic/angular';
import { UserLocation } from 'src/app/services/enode/enode.types';

@Component({
  selector: 'app-add-location-modal',
  templateUrl: './add-location-modal.component.html',
  styleUrls: ['./add-location-modal.component.scss']
})
export class AddLocationModalComponent {
  @ViewChild(IonContent) content: IonContent;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {}

  save(location: UserLocation) {
    this.modalCtrl.dismiss({
      location: {
        id: location.id,
        name: location.name,
        latitude: location.latitude,
        longitude: location.longitude,
        timezoneName: 'Europe/Oslo'
      } as UserLocation
    });
  }

  cancel() {
    this.modalCtrl.dismiss();
  }
}
